import React, { Component } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Container,
  FormGroup,
  Label,
  Input,
  Progress,
  Badge,
} from "reactstrap";
import {
  getCouponById,
  createCoupon,
  updateCoupon,
  getRoomTypeList,
  getRoomList,
  getFoodCuisineList,
  getFoodList,
  getTableList,
  getTransportServicesAdmin,
} from "../../Endpoint/Admin/index";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";

class CouponForm extends Component {
  constructor(props) {
    super(props);
    const couponId = this.props.match?.params?.id;

    // Theme gradient definitions
    this.themeGradients = {
      purple: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      sunset: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      ocean: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      forest: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
      fire: "linear-gradient(135deg, #f12711 0%, #f5af19 100%)",
      dark: "linear-gradient(135deg, #232526 0%, #414345 100%)",
      gold: "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)",
      blue: "linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)",
    };

    this.state = {
      couponId: couponId || null,
      isEditMode: !!couponId,
      isLoading: couponId ? true : false,
      currentStep: 1,
      totalSteps: 5,

      // Dropdown data
      roomTypes: [],
      rooms: [],
      cuisines: [],
      foods: [],
      tables: [],
      transportServices: [],

      // Step 1: Basic Info
      code: "",
      name: "",
      description: "",

      // Step 2: Appearance/Theme
      backgroundType: "gradient",
      backgroundTheme: "purple",
      backgroundImage: null,
      backgroundImageUrl: null,
      backgroundImageFile: null,
      backgroundImagePreview: null,
      textColor: "light",

      // Step 3: Discount
      discountType: "percentage",
      discountValue: "",
      minOrderAmount: "",
      maxDiscount: "",

      // Step 4: Where to Apply
      applyTo: "all", // all, specific
      selectedCategory: "", // food, room, table, transport (single selection)
      // Granular selections
      selectedRoomTypes: [],
      selectedRooms: [],
      selectedCuisines: [],
      selectedFoods: [],
      selectedTables: [],
      selectedTransportServices: [],
      selectedOrderPlaceTypes: [], // For food: 1=Room Service, 2=Dine In, 3=Pickup, 4=Home Delivery

      // Step 5: Rules & Validity
      userType: "all",
      loyaltyMinOrders: 5,
      loyaltyMinSpending: 50000,
      usageLimit: "",
      usageLimitPerUser: 1,
      startDate: "",
      endDate: "",
      isActive: true,

      breadcrumbItems: [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Coupons", link: "/coupon" },
        { title: couponId ? "Edit Coupon" : "Create Coupon", link: "#" },
      ],
    };
  }

  componentDidMount() {
    this.loadDropdownData();
    if (this.state.couponId) {
      this.loadCoupon();
    }
  }

  loadDropdownData = async () => {
    try {
      const [roomTypesRes, roomsRes, cuisinesRes, foodsRes, tablesRes, transportRes] = await Promise.all([
        getRoomTypeList(),
        getRoomList(),
        getFoodCuisineList(),
        getFoodList(),
        getTableList(),
        getTransportServicesAdmin(),
      ]);

      this.setState({
        roomTypes: roomTypesRes?.data || [],
        rooms: roomsRes?.data || [],
        cuisines: cuisinesRes?.data || [],
        foods: foodsRes?.data || [],
        tables: tablesRes?.data || [],
        transportServices: transportRes?.data || [],
      });
    } catch (error) {
      console.error("Error loading dropdown data:", error);
    }
  };

  loadCoupon = () => {
    getCouponById(this.state.couponId)
      .then((result) => {
        if (result.status === 200) {
          const coupon = result.data;
          this.setState({
            isLoading: false,
            code: coupon.code || "",
            name: coupon.name || "",
            description: coupon.description || "",
            // Background/Theme
            backgroundType: coupon.backgroundType || "gradient",
            backgroundTheme: coupon.backgroundTheme || "purple",
            backgroundImageUrl: coupon.backgroundImageUrl || null,
            textColor: coupon.textColor || "light",
            // Discount
            discountType: coupon.discountType || "percentage",
            discountValue: coupon.discountValue || "",
            minOrderAmount: coupon.minOrderValue || "",
            maxDiscount: coupon.uptoAmount || "",
            applyTo: coupon.scopeLevel === "all" ? "all" : "specific",
            selectedCategory: coupon.applicableCategories?.[0] || "",
            selectedRoomTypes: coupon.applicableRoomTypes?.map(r => r._id || r) || [],
            selectedRooms: coupon.applicableRooms?.map(r => r._id || r) || [],
            selectedCuisines: coupon.applicableCuisines?.map(c => c._id || c) || [],
            selectedFoods: coupon.applicableFoodItems?.map(f => f._id || f) || [],
            selectedTables: coupon.applicableTables?.map(t => t._id || t) || [],
            selectedTransportServices: coupon.applicableTransportServices?.map(t => t._id || t) || [],
            selectedOrderPlaceTypes: coupon.applicableOrderPlaceTypes || [],
            userType: coupon.userType || "all",
            loyaltyMinOrders: coupon.loyaltyMinOrders || 5,
            loyaltyMinSpending: coupon.loyaltyMinSpending || 50000,
            usageLimit: coupon.usageLimit || "",
            usageLimitPerUser: coupon.usagePerUser || 1,
            startDate: coupon.startDate ? coupon.startDate.split("T")[0] : "",
            endDate: coupon.expiryDate ? coupon.expiryDate.split("T")[0] : "",
            isActive: coupon.isActive !== false,
          });
        } else {
          toast.error(result.message || "Failed to load coupon");
          this.props.history.push("/coupon");
        }
      })
      .catch(() => {
        toast.error("Error loading coupon");
        this.props.history.push("/coupon");
      });
  };

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({
      [name]: type === "checkbox" ? checked : value,
    });
  };

  generateCode = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let code = "";
    for (let i = 0; i < 8; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    this.setState({ code });
  };

  handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
      if (!validTypes.includes(file.type)) {
        toast.error("Please upload a valid image (JPG, PNG, or WebP)");
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error("Image size must be less than 5MB");
        return;
      }

      // Create preview URL
      const previewUrl = URL.createObjectURL(file);

      this.setState({
        backgroundType: "image",
        backgroundImageFile: file,
        backgroundImagePreview: previewUrl,
      });
    }
  };

  removeBackgroundImage = () => {
    // Revoke the preview URL to free memory
    if (this.state.backgroundImagePreview) {
      URL.revokeObjectURL(this.state.backgroundImagePreview);
    }
    this.setState({
      backgroundType: "gradient",
      backgroundImageFile: null,
      backgroundImagePreview: null,
      backgroundImageUrl: null, // Clear existing server image URL
      backgroundImage: null,
    });
  };

  selectCategory = (category) => {
    const { selectedCategory } = this.state;

    // If clicking the same category, deselect it
    if (selectedCategory === category) {
      this.setState({
        selectedCategory: "",
        // Clear all related selections
        selectedRoomTypes: [],
        selectedRooms: [],
        selectedCuisines: [],
        selectedFoods: [],
        selectedTables: [],
        selectedTransportServices: [],
        selectedOrderPlaceTypes: [],
      });
    } else {
      // Select new category and clear all previous selections
      this.setState({
        selectedCategory: category,
        selectedRoomTypes: [],
        selectedRooms: [],
        selectedCuisines: [],
        selectedFoods: [],
        selectedTables: [],
        selectedTransportServices: [],
        selectedOrderPlaceTypes: [],
      });
    }
  };

  toggleArrayItem = (field, itemId) => {
    const currentArray = this.state[field];
    if (currentArray.includes(itemId)) {
      this.setState({ [field]: currentArray.filter((id) => id !== itemId) });
    } else {
      this.setState({ [field]: [...currentArray, itemId] });
    }
  };

  nextStep = () => {
    const { currentStep, totalSteps } = this.state;
    if (this.validateCurrentStep()) {
      if (currentStep < totalSteps) {
        this.setState({ currentStep: currentStep + 1 });
      }
    }
  };

  prevStep = () => {
    const { currentStep } = this.state;
    if (currentStep > 1) {
      this.setState({ currentStep: currentStep - 1 });
    }
  };

  validateCurrentStep = () => {
    const { currentStep, code, name, discountValue, applyTo, selectedCategory } = this.state;

    switch (currentStep) {
      case 1:
        if (!code.trim()) {
          toast.error("Please enter a coupon code");
          return false;
        }
        if (!name.trim()) {
          toast.error("Please enter a coupon name");
          return false;
        }
        return true;

      case 2:
        // Appearance step - no required validation
        return true;

      case 3:
        if (!discountValue || parseFloat(discountValue) <= 0) {
          toast.error("Please enter a valid discount value");
          return false;
        }
        return true;

      case 4:
        if (applyTo === "specific" && !selectedCategory) {
          toast.error("Please select a category");
          return false;
        }
        return true;

      default:
        return true;
    }
  };

  handleSubmit = () => {
    if (!this.validateCurrentStep()) return;

    const {
      couponId,
      code,
      name,
      description,
      backgroundType,
      backgroundTheme,
      backgroundImageFile,
      textColor,
      discountType,
      discountValue,
      minOrderAmount,
      maxDiscount,
      applyTo,
      selectedCategory,
      selectedRoomTypes,
      selectedRooms,
      selectedCuisines,
      selectedFoods,
      selectedTables,
      selectedTransportServices,
      selectedOrderPlaceTypes,
      userType,
      loyaltyMinOrders,
      loyaltyMinSpending,
      usageLimit,
      usageLimitPerUser,
      startDate,
      endDate,
      isActive,
    } = this.state;

    // If there's an image file, use FormData
    if (backgroundImageFile) {
      const formData = new FormData();
      formData.append("couponImage", backgroundImageFile);
      formData.append("code", code.toUpperCase());
      formData.append("name", name);
      formData.append("description", description);
      formData.append("backgroundType", "image");
      formData.append("backgroundTheme", backgroundTheme);
      formData.append("textColor", textColor);
      formData.append("discountType", discountType);
      formData.append("discountValue", parseFloat(discountValue));
      formData.append("minOrderValue", minOrderAmount ? parseFloat(minOrderAmount) : 0);
      formData.append("uptoAmount", maxDiscount ? parseFloat(maxDiscount) : 0);
      formData.append("scopeLevel", applyTo === "all" ? "all" : "category");
      if (applyTo === "specific" && selectedCategory) {
        formData.append("applicableCategories[]", selectedCategory);
      }
      selectedRoomTypes.forEach(id => formData.append("applicableRoomTypes[]", id));
      selectedRooms.forEach(id => formData.append("applicableRooms[]", id));
      selectedCuisines.forEach(id => formData.append("applicableCuisines[]", id));
      selectedFoods.forEach(id => formData.append("applicableFoodItems[]", id));
      selectedTables.forEach(id => formData.append("applicableTables[]", id));
      selectedTransportServices.forEach(id => formData.append("applicableTransportServices[]", id));
      selectedOrderPlaceTypes.forEach(id => formData.append("applicableOrderPlaceTypes[]", id));
      formData.append("userType", userType);
      formData.append("loyaltyMinOrders", userType === "loyalty" ? parseInt(loyaltyMinOrders) : 5);
      formData.append("loyaltyMinSpending", userType === "loyalty" ? parseFloat(loyaltyMinSpending) : 50000);
      formData.append("usageLimit", usageLimit ? parseInt(usageLimit) : 0);
      // 0 means unlimited per user
      formData.append("usagePerUser", parseInt(usageLimitPerUser) >= 0 ? parseInt(usageLimitPerUser) : 1);
      formData.append("startDate", startDate || new Date().toISOString().split("T")[0]);
      formData.append("expiryDate", endDate || new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]);
      formData.append("isActive", isActive);

      const apiCall = couponId ? updateCoupon(couponId, formData) : createCoupon(formData);
      this.executeApiCall(apiCall, couponId);
      return;
    }

    // No image - use JSON
    const couponData = {
      code: code.toUpperCase(),
      name,
      description,
      backgroundType,
      backgroundTheme,
      textColor,
      discountType,
      discountValue: parseFloat(discountValue),
      minOrderValue: minOrderAmount ? parseFloat(minOrderAmount) : 0,
      uptoAmount: maxDiscount ? parseFloat(maxDiscount) : 0,
      scopeLevel: applyTo === "all" ? "all" : "category",
      applicableCategories: applyTo === "specific" && selectedCategory ? [selectedCategory] : [],
      applicableRoomTypes: selectedRoomTypes,
      applicableRooms: selectedRooms,
      applicableCuisines: selectedCuisines,
      applicableFoodItems: selectedFoods,
      applicableTables: selectedTables,
      applicableTransportServices: selectedTransportServices,
      applicableOrderPlaceTypes: selectedOrderPlaceTypes,
      userType,
      loyaltyMinOrders: userType === "loyalty" ? parseInt(loyaltyMinOrders) : 5,
      loyaltyMinSpending: userType === "loyalty" ? parseFloat(loyaltyMinSpending) : 50000,
      usageLimit: usageLimit ? parseInt(usageLimit) : 0,
      usagePerUser: parseInt(usageLimitPerUser) >= 0 ? parseInt(usageLimitPerUser) : 1, // 0 means unlimited per user
      startDate: startDate || new Date().toISOString().split("T")[0],
      expiryDate: endDate || new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
      isActive,
    };

    const apiCall = couponId ? updateCoupon(couponId, couponData) : createCoupon(couponData);
    this.executeApiCall(apiCall, couponId);
  };

  executeApiCall = (apiCall, couponId) => {
    apiCall
      .then((response) => {
        if (response && response.status === 200) {
          toast.success(couponId ? "Coupon updated!" : "Coupon created!");
          setTimeout(() => this.props.history.push("/coupon"), 1500);
        } else {
          toast.error(response?.message || "Failed to save coupon");
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error saving coupon");
      });
  };

  // Get display text for where coupon applies
  getAppliesTo = () => {
    const { applyTo, selectedCategory, selectedRoomTypes, selectedCuisines, selectedTables, selectedTransportServices, roomTypes, cuisines, transportServices } = this.state;

    if (applyTo === "all") return "All Services";

    if (!selectedCategory) return "Not selected";

    switch (selectedCategory) {
      case "food":
        if (selectedCuisines.length > 0) {
          const cuisineNames = cuisines.filter(c => selectedCuisines.includes(c._id)).map(c => c.cuisineName);
          return `Food (${cuisineNames.join(", ")})`;
        }
        return "All Food";

      case "room":
        if (selectedRoomTypes.length > 0) {
          const typeNames = roomTypes.filter(r => selectedRoomTypes.includes(r._id)).map(r => r.roomTypeName);
          return `Rooms (${typeNames.join(", ")})`;
        }
        return "All Rooms";

      case "table":
        return selectedTables.length > 0 ? `${selectedTables.length} Tables` : "All Tables";

      case "transport":
        if (selectedTransportServices.length > 0) {
          const serviceNames = transportServices.filter(s => selectedTransportServices.includes(s._id)).map(s => s.serviceName);
          return `Transport (${serviceNames.join(", ")})`;
        }
        return "All Transport";

      default:
        return "Not selected";
    }
  };

  renderCouponPreview = () => {
    const {
      code,
      name,
      description,
      backgroundType,
      backgroundTheme,
      backgroundImagePreview,
      backgroundImageUrl,
      textColor,
      discountType,
      discountValue,
      minOrderAmount,
      maxDiscount,
      userType,
      loyaltyMinOrders,
      startDate,
      endDate,
      isActive,
    } = this.state;

    const discountDisplay = discountValue
      ? discountType === "percentage"
        ? `${discountValue}% OFF`
        : `$${discountValue} OFF`
      : "-- OFF";

    // Determine background
    let backgroundStyle = {};
    // For server images, prepend API base URL
    const serverImageUrl = backgroundImageUrl && !backgroundImageUrl.startsWith('blob:') && !backgroundImageUrl.startsWith('http')
      ? `${process.env.REACT_APP_DEFAULTAUTH}${backgroundImageUrl}`
      : backgroundImageUrl;
    const imageUrl = backgroundImagePreview || serverImageUrl;

    if (!isActive) {
      backgroundStyle = { background: "linear-gradient(135deg, #6c757d 0%, #495057 100%)" };
    } else if (backgroundType === "image" && imageUrl) {
      backgroundStyle = {
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      };
    } else {
      backgroundStyle = { background: this.themeGradients[backgroundTheme] || this.themeGradients.purple };
    }

    // Text color
    const textColorStyle = textColor === "dark" ? "#343a40" : "#ffffff";
    const overlayOpacity = backgroundType === "image" ? 0.5 : 0;

    return (
      <div className="coupon-preview-card">
        {/* Coupon Visual */}
        <div
          className="position-relative overflow-hidden rounded-lg"
          style={{
            ...backgroundStyle,
            padding: "24px",
            color: textColorStyle,
            minHeight: "180px",
          }}
        >
          {/* Dark overlay for image backgrounds */}
          {backgroundType === "image" && imageUrl && (
            <div
              className="position-absolute"
              style={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: `rgba(0,0,0,${overlayOpacity})`,
                zIndex: 0,
              }}
            />
          )}

          {/* Decorative circles */}
          <div
            className="position-absolute"
            style={{
              width: "20px",
              height: "20px",
              background: "#f8f9fa",
              borderRadius: "50%",
              left: "-10px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 2,
            }}
          />
          <div
            className="position-absolute"
            style={{
              width: "20px",
              height: "20px",
              background: "#f8f9fa",
              borderRadius: "50%",
              right: "-10px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 2,
            }}
          />

          {/* Content with z-index */}
          <div style={{ position: "relative", zIndex: 1 }}>
            {/* Discount Badge */}
            <div className="text-center mb-3">
              <span
                style={{
                  fontSize: "32px",
                  fontWeight: "800",
                  textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                }}
              >
                {discountDisplay}
              </span>
            </div>

            {/* Coupon Code */}
            <div
              className="text-center py-2 mb-3 rounded"
              style={{
                background: "rgba(255,255,255,0.2)",
                border: "2px dashed rgba(255,255,255,0.5)",
              }}
            >
              <span style={{ fontFamily: "monospace", fontSize: "20px", letterSpacing: "3px" }}>
                {code || "CODE"}
              </span>
            </div>

            {/* Coupon Name */}
            <div className="text-center">
              <h5 className="mb-1" style={{ fontWeight: "600" }}>
                {name || "Coupon Name"}
              </h5>
              {description && (
                <small style={{ opacity: 0.9 }}>{description}</small>
              )}
            </div>
          </div>
        </div>

        {/* Details Section */}
        <div className="mt-3 p-3 bg-light rounded">
          <h6 className="text-muted mb-3">
            <i className="ri-information-line mr-1"></i> Details
          </h6>

          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted">Applies to:</span>
            <span className="font-weight-medium text-right" style={{ maxWidth: "60%", fontSize: "12px" }}>
              {this.getAppliesTo()}
            </span>
          </div>

          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted">Min. Order:</span>
            <span className="font-weight-medium">
              {minOrderAmount ? `$${minOrderAmount}` : "None"}
            </span>
          </div>

          {discountType === "percentage" && maxDiscount && (
            <div className="d-flex justify-content-between mb-2">
              <span className="text-muted">Max Discount:</span>
              <span className="font-weight-medium">${maxDiscount}</span>
            </div>
          )}

          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted">Who can use:</span>
            <span className="font-weight-medium">
              {userType === "all" && "All Users"}
              {userType === "first_time" && "First Time Only"}
              {userType === "loyalty" && `Loyal (${loyaltyMinOrders}+ orders)`}
            </span>
          </div>

          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted">Valid:</span>
            <span className="font-weight-medium">
              {startDate || "Today"} - {endDate || "No Expiry"}
            </span>
          </div>

          <div className="d-flex justify-content-between">
            <span className="text-muted">Status:</span>
            <Badge color={isActive ? "success" : "secondary"}>
              {isActive ? "Active" : "Inactive"}
            </Badge>
          </div>
        </div>
      </div>
    );
  };

  renderStep1 = () => {
    const { code, name, description } = this.state;

    return (
      <div>
        <h5 className="mb-4">
          <span className="badge badge-primary mr-2">1</span>
          Basic Information
        </h5>

        <FormGroup>
          <Label>Coupon Code *</Label>
          <Row>
            <Col xs={8}>
              <Input
                type="text"
                name="code"
                value={code}
                onChange={this.handleChange}
                placeholder="e.g., SUMMER20"
                className="text-uppercase"
                style={{ fontFamily: "monospace", letterSpacing: "2px", fontSize: "16px" }}
              />
            </Col>
            <Col xs={4}>
              <Button color="outline-primary" className="w-100" onClick={this.generateCode}>
                <i className="ri-refresh-line mr-1"></i> Generate
              </Button>
            </Col>
          </Row>
          <small className="text-muted">Letters and numbers only, no spaces</small>
        </FormGroup>

        <FormGroup>
          <Label>Coupon Name *</Label>
          <Input
            type="text"
            name="name"
            value={name}
            onChange={this.handleChange}
            placeholder="e.g., Summer Sale - 20% Off"
          />
          <small className="text-muted">A friendly name to identify this coupon</small>
        </FormGroup>

        <FormGroup>
          <Label>Description</Label>
          <Input
            type="textarea"
            name="description"
            value={description}
            onChange={this.handleChange}
            rows={2}
            placeholder="Brief description for customers..."
          />
        </FormGroup>
      </div>
    );
  };

  renderStep2 = () => {
    const { backgroundType, backgroundTheme, backgroundImagePreview, backgroundImageUrl, textColor } = this.state;
    // For existing images from server, prepend API base URL
    const serverImageUrl = backgroundImageUrl && !backgroundImageUrl.startsWith('blob:')
      ? `${process.env.REACT_APP_DEFAULTAUTH}${backgroundImageUrl}`
      : null;
    const imagePreview = backgroundImagePreview || serverImageUrl;

    const themes = [
      { id: "purple", name: "Purple", gradient: this.themeGradients.purple },
      { id: "sunset", name: "Sunset", gradient: this.themeGradients.sunset },
      { id: "ocean", name: "Ocean", gradient: this.themeGradients.ocean },
      { id: "forest", name: "Forest", gradient: this.themeGradients.forest },
      { id: "fire", name: "Fire", gradient: this.themeGradients.fire },
      { id: "dark", name: "Dark", gradient: this.themeGradients.dark },
      { id: "gold", name: "Gold", gradient: this.themeGradients.gold },
      { id: "blue", name: "Blue", gradient: this.themeGradients.blue },
    ];

    return (
      <div>
        <h5 className="mb-4">
          <span className="badge badge-primary mr-2">2</span>
          Appearance
        </h5>

        {/* Background Type Selection */}
        <FormGroup>
          <Label>Background Type</Label>
          <div className="d-flex mb-3">
            <Button
              color={backgroundType === "gradient" ? "primary" : "light"}
              className="mr-2 flex-grow-1"
              onClick={() => this.setState({ backgroundType: "gradient" })}
            >
              <i className="ri-palette-line mr-1"></i> Theme
            </Button>
            <Button
              color={backgroundType === "image" ? "primary" : "light"}
              className="flex-grow-1"
              onClick={() => this.setState({ backgroundType: "image" })}
            >
              <i className="ri-image-line mr-1"></i> Custom Image
            </Button>
          </div>
        </FormGroup>

        {/* Theme Selection */}
        {backgroundType === "gradient" && (
          <FormGroup>
            <Label>Select Theme</Label>
            <Row>
              {themes.map((theme) => (
                <Col xs={3} key={theme.id} className="mb-2">
                  <div
                    className={`rounded text-center p-2 cursor-pointer ${
                      backgroundTheme === theme.id ? "ring-2 ring-primary" : ""
                    }`}
                    style={{
                      background: theme.gradient,
                      height: "60px",
                      cursor: "pointer",
                      border: backgroundTheme === theme.id ? "3px solid #5664d2" : "3px solid transparent",
                      transition: "all 0.2s",
                    }}
                    onClick={() => this.setState({ backgroundTheme: theme.id })}
                  >
                    {backgroundTheme === theme.id && (
                      <i className="ri-checkbox-circle-fill text-white" style={{ fontSize: "20px" }}></i>
                    )}
                  </div>
                  <small className="d-block text-center mt-1 text-muted">{theme.name}</small>
                </Col>
              ))}
            </Row>
          </FormGroup>
        )}

        {/* Image Upload */}
        {backgroundType === "image" && (
          <FormGroup>
            <Label>Upload Background Image</Label>
            {imagePreview ? (
              <div className="mb-3">
                <div className="position-relative">
                  <img
                    src={imagePreview}
                    alt="Background Preview"
                    className="w-100 rounded"
                    style={{ height: "120px", objectFit: "cover" }}
                  />
                  <Button
                    color="danger"
                    size="sm"
                    className="position-absolute"
                    style={{ top: "8px", right: "8px" }}
                    onClick={this.removeBackgroundImage}
                    title="Remove image"
                  >
                    <i className="ri-close-line"></i>
                  </Button>
                </div>
                <div className="d-flex mt-2">
                  <Button
                    color="outline-primary"
                    size="sm"
                    className="flex-grow-1"
                    onClick={() => document.getElementById("couponImageInput").click()}
                  >
                    <i className="ri-refresh-line mr-1"></i> Replace Image
                  </Button>
                </div>
              </div>
            ) : (
              <div
                className="border rounded p-4 text-center bg-light"
                style={{ cursor: "pointer" }}
                onClick={() => document.getElementById("couponImageInput").click()}
              >
                <i className="ri-upload-cloud-2-line d-block mb-2" style={{ fontSize: "32px", color: "var(--text-muted)" }}></i>
                <span className="text-muted">Click to upload image</span>
                <br />
                <small className="text-muted">JPG, PNG, WebP (Max 5MB)</small>
              </div>
            )}
            <input
              type="file"
              id="couponImageInput"
              className="d-none"
              accept="image/jpeg,image/jpg,image/png,image/webp"
              onChange={this.handleImageUpload}
            />
            {!imagePreview && (
              <Button
                color="outline-primary"
                className="mt-2 w-100"
                onClick={() => document.getElementById("couponImageInput").click()}
              >
                <i className="ri-upload-line mr-1"></i> Choose Image
              </Button>
            )}
          </FormGroup>
        )}

        {/* Text Color */}
        <FormGroup>
          <Label>Text Color</Label>
          <div className="d-flex">
            <Button
              color={textColor === "light" ? "dark" : "light"}
              className="mr-2 flex-grow-1"
              onClick={() => this.setState({ textColor: "light" })}
            >
              <span className="text-white bg-dark px-2 py-1 rounded mr-1">Aa</span> Light Text
            </Button>
            <Button
              color={textColor === "dark" ? "dark" : "light"}
              className="flex-grow-1"
              onClick={() => this.setState({ textColor: "dark" })}
            >
              <span className="text-dark bg-light px-2 py-1 rounded mr-1 border">Aa</span> Dark Text
            </Button>
          </div>
          <small className="text-muted mt-1 d-block">Choose based on your background for better readability</small>
        </FormGroup>
      </div>
    );
  };

  renderStep3 = () => {
    const { discountType, discountValue, minOrderAmount, maxDiscount } = this.state;

    return (
      <div>
        <h5 className="mb-4">
          <span className="badge badge-primary mr-2">3</span>
          Discount Settings
        </h5>

        <FormGroup>
          <Label>Discount Type</Label>
          <div className="d-flex">
            <Button
              color={discountType === "percentage" ? "primary" : "light"}
              className="mr-2 flex-grow-1"
              onClick={() => this.setState({ discountType: "percentage" })}
            >
              <i className="ri-percent-line mr-1"></i> Percentage
            </Button>
            <Button
              color={discountType === "fixed" ? "primary" : "light"}
              className="flex-grow-1"
              onClick={() => this.setState({ discountType: "fixed" })}
            >
              <i className="ri-money-dollar-circle-line mr-1"></i> Fixed Amount
            </Button>
          </div>
        </FormGroup>

        <FormGroup>
          <Label>Discount Value *</Label>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                {discountType === "percentage" ? "%" : "$"}
              </span>
            </div>
            <Input
              type="number"
              name="discountValue"
              value={discountValue}
              onChange={this.handleChange}
              placeholder={discountType === "percentage" ? "e.g., 20" : "e.g., 500"}
              min="0"
              max={discountType === "percentage" ? "100" : undefined}
            />
          </div>
        </FormGroup>

        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Minimum Order Amount</Label>
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">$</span>
                </div>
                <Input
                  type="number"
                  name="minOrderAmount"
                  value={minOrderAmount}
                  onChange={this.handleChange}
                  placeholder="e.g., 100"
                  min="0"
                />
              </div>
              <small className="text-muted">Leave empty for no minimum</small>
            </FormGroup>
          </Col>
          {discountType === "percentage" && (
            <Col md={6}>
              <FormGroup>
                <Label>Maximum Discount Cap</Label>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">$</span>
                  </div>
                  <Input
                    type="number"
                    name="maxDiscount"
                    value={maxDiscount}
                    onChange={this.handleChange}
                    placeholder="e.g., 500"
                    min="0"
                  />
                </div>
                <small className="text-muted">Leave empty for no cap</small>
              </FormGroup>
            </Col>
          )}
        </Row>
      </div>
    );
  };

  renderStep4 = () => {
    const {
      applyTo,
      selectedCategory,
      selectedRoomTypes,
      selectedRooms,
      selectedCuisines,
      selectedFoods,
      selectedTables,
      selectedTransportServices,
      roomTypes,
      rooms,
      cuisines,
      foods,
      tables,
      transportServices,
    } = this.state;

    return (
      <div>
        <h5 className="mb-4">
          <span className="badge badge-primary mr-2">4</span>
          Where to Apply
        </h5>

        <FormGroup>
          <div className="d-flex mb-3">
            <Button
              color={applyTo === "all" ? "success" : "light"}
              className="mr-2 flex-grow-1"
              onClick={() => this.setState({ applyTo: "all", selectedCategory: "", selectedRoomTypes: [], selectedRooms: [], selectedCuisines: [], selectedFoods: [], selectedTables: [], selectedTransportServices: [], selectedOrderPlaceTypes: [] })}
            >
              <i className="ri-global-line mr-1"></i> All Services
            </Button>
            <Button
              color={applyTo === "specific" ? "primary" : "light"}
              className="flex-grow-1"
              onClick={() => this.setState({ applyTo: "specific" })}
            >
              <i className="ri-filter-3-line mr-1"></i> Specific Category
            </Button>
          </div>
        </FormGroup>

        {applyTo === "specific" && (
          <>
            {/* Category Selection - Single Select */}
            <div className="mb-4">
              <Label className="d-block mb-3">Select One Category</Label>
              <Row>
                {[
                  { id: "food", icon: "ri-restaurant-line", label: "Food", color: "warning", desc: "Food orders & cuisines" },
                  { id: "room", icon: "ri-hotel-bed-line", label: "Room", color: "primary", desc: "Room bookings" },
                  { id: "table", icon: "ri-layout-grid-line", label: "Table", color: "success", desc: "Table reservations" },
                  { id: "transport", icon: "ri-car-line", label: "Transport", color: "info", desc: "Airport, Intercity, Outstation" },
                ].map((cat) => (
                  <Col xs={6} md={3} key={cat.id} className="mb-2">
                    <div
                      className={`p-3 rounded text-center cursor-pointer border ${
                        selectedCategory === cat.id
                          ? `border-${cat.color} bg-soft-${cat.color}`
                          : "border-light"
                      }`}
                      style={{ cursor: "pointer", transition: "all 0.2s" }}
                      onClick={() => this.selectCategory(cat.id)}
                    >
                      <i className={`${cat.icon} d-block mb-1 text-${cat.color}`} style={{ fontSize: "24px" }}></i>
                      <span className="font-weight-medium d-block">{cat.label}</span>
                      <small className="text-muted">{cat.desc}</small>
                      {selectedCategory === cat.id && (
                        <i className="ri-checkbox-circle-fill text-success d-block mt-1"></i>
                      )}
                    </div>
                  </Col>
                ))}
              </Row>
            </div>

            {/* Food Sub-selection */}
            {selectedCategory === "food" && (
              <Card className="border mb-3">
                <CardBody>
                  <h6 className="text-warning mb-3">
                    <i className="ri-restaurant-line mr-1"></i> Food Options
                  </h6>

                  <FormGroup>
                    <Label>Select Cuisines (optional)</Label>
                    <div className="d-flex flex-wrap">
                      {cuisines.map((cuisine) => (
                        <Badge
                          key={cuisine._id}
                          color={selectedCuisines.includes(cuisine._id) ? "warning" : "light"}
                          className="mr-2 mb-2 p-2 cursor-pointer"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.toggleArrayItem("selectedCuisines", cuisine._id)}
                        >
                          {cuisine.cuisineName}
                          {selectedCuisines.includes(cuisine._id) && (
                            <i className="ri-close-line ml-1"></i>
                          )}
                        </Badge>
                      ))}
                    </div>
                    <small className="text-muted">Leave empty to apply to all cuisines</small>
                  </FormGroup>

                  {selectedCuisines.length > 0 && (
                    <FormGroup>
                      <Label>Select Specific Food Items (optional)</Label>
                      <div className="d-flex flex-wrap" style={{ maxHeight: "150px", overflowY: "auto" }}>
                        {foods
                          .filter((f) => selectedCuisines.includes(f.foodCuisine?._id || f.foodCuisine))
                          .map((food) => (
                            <Badge
                              key={food._id}
                              color={selectedFoods.includes(food._id) ? "dark" : "light"}
                              className="mr-2 mb-2 p-2 cursor-pointer"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.toggleArrayItem("selectedFoods", food._id)}
                            >
                              {food.foodName}
                            </Badge>
                          ))}
                      </div>
                    </FormGroup>
                  )}

                  <FormGroup>
                    <Label>Order Type (optional)</Label>
                    <div className="d-flex flex-wrap">
                      {[
                        { id: 1, label: "Room Service", icon: "ri-hotel-line" },
                        { id: 2, label: "Dine In", icon: "ri-restaurant-2-line" },
                        { id: 3, label: "Pickup", icon: "ri-shopping-bag-line" },
                        { id: 4, label: "Home Delivery", icon: "ri-e-bike-2-line" },
                      ].map((opt) => (
                        <Badge
                          key={opt.id}
                          color={this.state.selectedOrderPlaceTypes.includes(opt.id) ? "warning" : "light"}
                          className="mr-2 mb-2 p-2 cursor-pointer"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.toggleArrayItem("selectedOrderPlaceTypes", opt.id)}
                        >
                          <i className={`${opt.icon} mr-1`}></i>
                          {opt.label}
                          {this.state.selectedOrderPlaceTypes.includes(opt.id) && (
                            <i className="ri-close-line ml-1"></i>
                          )}
                        </Badge>
                      ))}
                    </div>
                    <small className="text-muted">Leave empty to apply to all order types</small>
                  </FormGroup>
                </CardBody>
              </Card>
            )}

            {/* Room Sub-selection */}
            {selectedCategory === "room" && (
              <Card className="border mb-3">
                <CardBody>
                  <h6 className="text-primary mb-3">
                    <i className="ri-hotel-bed-line mr-1"></i> Room Options
                  </h6>

                  <FormGroup>
                    <Label>Select Room Types (optional)</Label>
                    <div className="d-flex flex-wrap">
                      {roomTypes.map((type) => (
                        <Badge
                          key={type._id}
                          color={selectedRoomTypes.includes(type._id) ? "primary" : "light"}
                          className="mr-2 mb-2 p-2 cursor-pointer"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.toggleArrayItem("selectedRoomTypes", type._id)}
                        >
                          {type.roomTypeName}
                          {selectedRoomTypes.includes(type._id) && (
                            <i className="ri-close-line ml-1"></i>
                          )}
                        </Badge>
                      ))}
                    </div>
                    <small className="text-muted">Leave empty to apply to all room types</small>
                  </FormGroup>

                  {selectedRoomTypes.length > 0 && (
                    <FormGroup>
                      <Label>Select Specific Rooms (optional)</Label>
                      <div className="d-flex flex-wrap" style={{ maxHeight: "150px", overflowY: "auto" }}>
                        {rooms
                          .filter((r) => selectedRoomTypes.includes(r.roomType?._id || r.roomType))
                          .map((room) => (
                            <Badge
                              key={room._id}
                              color={selectedRooms.includes(room._id) ? "dark" : "light"}
                              className="mr-2 mb-2 p-2 cursor-pointer"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.toggleArrayItem("selectedRooms", room._id)}
                            >
                              {room.roomName}
                            </Badge>
                          ))}
                      </div>
                    </FormGroup>
                  )}
                </CardBody>
              </Card>
            )}

            {/* Table Sub-selection */}
            {selectedCategory === "table" && (
              <Card className="border mb-3">
                <CardBody>
                  <h6 className="text-success mb-3">
                    <i className="ri-layout-grid-line mr-1"></i> Table Options
                  </h6>

                  <FormGroup>
                    <Label>Select Specific Tables (optional)</Label>
                    <div className="d-flex flex-wrap">
                      {tables.map((table) => (
                        <Badge
                          key={table._id}
                          color={selectedTables.includes(table._id) ? "success" : "light"}
                          className="mr-2 mb-2 p-2 cursor-pointer"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.toggleArrayItem("selectedTables", table._id)}
                        >
                          Table {table.tableNo} ({table.seats} seats)
                        </Badge>
                      ))}
                    </div>
                    <small className="text-muted">Leave empty to apply to all tables</small>
                  </FormGroup>
                </CardBody>
              </Card>
            )}

            {/* Transport Sub-selection */}
            {selectedCategory === "transport" && (
              <Card className="border mb-3">
                <CardBody>
                  <h6 className="text-info mb-3">
                    <i className="ri-car-line mr-1"></i> Transport Options
                  </h6>

                  <FormGroup>
                    <Label>Select Transport Services (optional)</Label>
                    <div className="d-flex flex-wrap">
                      {transportServices.map((service) => (
                        <Badge
                          key={service._id}
                          color={selectedTransportServices.includes(service._id) ? "info" : "light"}
                          className="mr-2 mb-2 p-2 cursor-pointer"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.toggleArrayItem("selectedTransportServices", service._id)}
                        >
                          <i className={`${service.icon || 'ri-car-line'} mr-1`}></i>
                          {service.serviceName}
                          {selectedTransportServices.includes(service._id) && (
                            <i className="ri-close-line ml-1"></i>
                          )}
                        </Badge>
                      ))}
                    </div>
                    <small className="text-muted">Leave empty to apply to all transport services (Airport, Intercity, Outstation)</small>
                  </FormGroup>

                  {transportServices.length === 0 && (
                    <div className="text-muted text-center py-3">
                      <i className="ri-car-line ri-2x mb-2 d-block"></i>
                      No transport services found. Run seed script first.
                    </div>
                  )}
                </CardBody>
              </Card>
            )}
          </>
        )}

        {applyTo === "all" && (
          <div className="text-center p-4 bg-soft-success rounded">
            <i className="ri-checkbox-circle-line text-success" style={{ fontSize: "48px" }}></i>
            <h6 className="mt-2 mb-0">This coupon applies to all services</h6>
            <small className="text-muted">Food, Room, Table, and Transport bookings</small>
          </div>
        )}
      </div>
    );
  };

  renderStep5 = () => {
    const { userType, loyaltyMinOrders, loyaltyMinSpending, usageLimit, usageLimitPerUser, startDate, endDate, isActive } = this.state;

    return (
      <div>
        <h5 className="mb-4">
          <span className="badge badge-primary mr-2">5</span>
          Rules & Validity
        </h5>

        <FormGroup>
          <Label>Who Can Use</Label>
          <div className="d-flex flex-wrap">
            {[
              { id: "all", icon: "ri-group-line", label: "All Users", desc: "Anyone can use" },
              { id: "first_time", icon: "ri-user-add-line", label: "First Time", desc: "New users only" },
              { id: "loyalty", icon: "ri-vip-crown-line", label: "Loyalty", desc: "Loyal customers" },
            ].map((type) => (
              <div
                key={type.id}
                className={`p-3 mr-2 mb-2 rounded text-center border flex-grow-1 ${
                  userType === type.id ? "border-primary bg-soft-primary" : "border-light"
                }`}
                style={{ cursor: "pointer", minWidth: "100px" }}
                onClick={() => this.setState({ userType: type.id })}
              >
                <i className={`${type.icon} d-block mb-1 ${userType === type.id ? "text-primary" : "text-muted"}`} style={{ fontSize: "20px" }}></i>
                <span className="font-weight-medium d-block" style={{ fontSize: "13px" }}>{type.label}</span>
                <small className="text-muted">{type.desc}</small>
              </div>
            ))}
          </div>
        </FormGroup>

        {/* Loyalty Configuration */}
        {userType === "loyalty" && (
          <Card className="border border-warning mb-3 bg-soft-warning">
            <CardBody>
              <h6 className="text-warning mb-3">
                <i className="ri-vip-crown-line mr-1"></i> Loyalty Criteria
              </h6>
              <p className="text-muted small mb-3">
                A user qualifies as "Loyal" if they meet <strong>EITHER</strong> of these conditions:
              </p>
              <Row>
                <Col md={6}>
                  <FormGroup className="mb-2">
                    <Label>Minimum Orders Completed</Label>
                    <div className="input-group">
                      <Input
                        type="number"
                        name="loyaltyMinOrders"
                        value={loyaltyMinOrders}
                        onChange={this.handleChange}
                        min="1"
                      />
                      <div className="input-group-append">
                        <span className="input-group-text">orders</span>
                      </div>
                    </div>
                    <small className="text-muted">User has completed at least this many orders</small>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup className="mb-2">
                    <Label>Minimum Total Spending</Label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">$</span>
                      </div>
                      <Input
                        type="number"
                        name="loyaltyMinSpending"
                        value={loyaltyMinSpending}
                        onChange={this.handleChange}
                        min="0"
                      />
                    </div>
                    <small className="text-muted">User has spent at least this amount</small>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}

        {/* First Time User Info */}
        {userType === "first_time" && (
          <div className="alert alert-info mb-3">
            <i className="ri-information-line mr-1"></i>
            <strong>First Time Users:</strong> Only users who have never made a purchase before can use this coupon.
          </div>
        )}

        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Total Usage Limit</Label>
              <Input
                type="number"
                name="usageLimit"
                value={usageLimit}
                onChange={this.handleChange}
                placeholder="Unlimited"
                min="1"
              />
              <small className="text-muted">Leave empty for unlimited</small>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Per User Limit</Label>
              <Input
                type="number"
                name="usageLimitPerUser"
                value={usageLimitPerUser}
                onChange={this.handleChange}
                min="1"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Start Date</Label>
              <Input
                type="date"
                name="startDate"
                value={startDate}
                onChange={this.handleChange}
              />
              <small className="text-muted">Leave empty for today</small>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>End Date</Label>
              <Input
                type="date"
                name="endDate"
                value={endDate}
                onChange={this.handleChange}
              />
              <small className="text-muted">Leave empty for no expiry</small>
            </FormGroup>
          </Col>
        </Row>

        <FormGroup>
          <div className="custom-control custom-switch">
            <input
              type="checkbox"
              className="custom-control-input"
              id="isActive"
              name="isActive"
              checked={isActive}
              onChange={this.handleChange}
            />
            <label className="custom-control-label" htmlFor="isActive">
              {isActive ? (
                <span className="text-success font-weight-bold">Active - Coupon is enabled</span>
              ) : (
                <span className="text-muted">Inactive - Coupon is disabled</span>
              )}
            </label>
          </div>
        </FormGroup>
      </div>
    );
  };

  render() {
    const { isEditMode, isLoading, currentStep, totalSteps } = this.state;

    if (isLoading) {
      return (
        <div className="page-content">
          <Container fluid>
            <div className="text-center py-5">
              <i className="ri-loader-4-line ri-2x spin"></i>
              <p className="mt-2">Loading coupon...</p>
            </div>
          </Container>
        </div>
      );
    }

    const stepTitles = ["Basic Info", "Appearance", "Discount", "Where to Apply", "Rules"];

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title={isEditMode ? "Edit Coupon" : "Create Coupon"}
              breadcrumbItems={this.state.breadcrumbItems}
            />

            <Row>
              {/* Form Section */}
              <Col lg={7}>
                <Card>
                  <CardBody>
                    {/* Progress Bar */}
                    <div className="mb-4">
                      <div className="d-flex justify-content-between mb-2">
                        {stepTitles.map((title, idx) => (
                          <span
                            key={idx}
                            className={`text-${currentStep > idx ? "success" : currentStep === idx + 1 ? "primary" : "muted"}`}
                            style={{ fontSize: "12px", fontWeight: currentStep === idx + 1 ? "600" : "400" }}
                          >
                            {title}
                          </span>
                        ))}
                      </div>
                      <Progress
                        value={(currentStep / totalSteps) * 100}
                        color="primary"
                        style={{ height: "6px" }}
                      />
                    </div>

                    {/* Step Content */}
                    <div className="step-content" style={{ minHeight: "350px" }}>
                      {currentStep === 1 && this.renderStep1()}
                      {currentStep === 2 && this.renderStep2()}
                      {currentStep === 3 && this.renderStep3()}
                      {currentStep === 4 && this.renderStep4()}
                      {currentStep === 5 && this.renderStep5()}
                    </div>

                    {/* Navigation */}
                    <div className="d-flex justify-content-between mt-4 pt-3 border-top">
                      <Button
                        color="light"
                        onClick={currentStep === 1 ? () => this.props.history.push("/coupon") : this.prevStep}
                      >
                        <i className="ri-arrow-left-line mr-1"></i>
                        {currentStep === 1 ? "Cancel" : "Back"}
                      </Button>

                      {currentStep < totalSteps ? (
                        <Button color="primary" onClick={this.nextStep}>
                          Next <i className="ri-arrow-right-line ml-1"></i>
                        </Button>
                      ) : (
                        <Button color="success" onClick={this.handleSubmit}>
                          <i className={`${isEditMode ? "ri-save-line" : "ri-check-line"} mr-1`}></i>
                          {isEditMode ? "Update Coupon" : "Create Coupon"}
                        </Button>
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Col>

              {/* Preview Section */}
              <Col lg={5}>
                <div className="sticky-top" style={{ top: "80px" }}>
                  <Card>
                    <CardBody>
                      <h5 className="card-title mb-4">
                        <i className="ri-eye-line mr-2"></i>
                        Live Preview
                      </h5>
                      {this.renderCouponPreview()}
                    </CardBody>
                  </Card>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <ToastContainer />
      </React.Fragment>
    );
  }
}

export default CouponForm;
